
import api from "./api";
import { format } from "date-fns";
export const getStates = async () => {
  try {
    const response = await api.get('/api/states/nationality/1');
    return response.data;
  } catch (error) {

    throw new Error('Error fetching states');
  }
};

export const getAllDistrictBihar = async () => {
  const response = await api.get(`/api/districts/state/3`)
  return response.data

}
export const getAllDistrictBiharZD = async () => {
  const response = await api.get(`/api/districts/3/zones-districts`)
  return response.data

}
export const getDistrict = async (state) => {
  const response = await api.get(`/api/districts/state/${state}`)
  return response.data

}
export const getDistrictByZoneId = async (zoneId) => {
  const response = await api.get(`/api/zones/${zoneId}`)
  return response.data

}
export const getZonesAll = async () => {
  const response = await api.get(`/api/zones`)
  return response.data

}
export const getBlocks = async (district) => {
  const response = await api.get(`/api/blocks/district/${district}`)
  return response.data;
}

export const getClients = async (state) => {
  const response = await api.get(`/api/clients/by-state/${state}`)
  return response.data

}
export const getProject = async (clients) => {
  const response = await api.get(`/api/projects/client/${clients}`);
  return response.data
}

export const getProjects = async () => {
  const response = await api.get(`/api/projects`);
  return response.data
}
// http://localhost:8080/api/projects/client/1

export const fetchAllMonths = async (year) => {
  // Fetch months data from API
  const response = await api.get("/api/months");
  const data = response.data;

  // Get the current date details
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1; // months are 0-indexed, so add 1
  const currentDate = now.getDate();
  const lastDayOfCurrentMonth = new Date(currentYear, currentMonth, 0).getDate();

  // Map through the months data and calculate the number of days
  const months = data
    .map((item) => {
      let daysInMonth;

      // For other years, show full month days
      daysInMonth = new Date(year, item.monthId, 0).getDate();


      return {
        value: item.monthId,
        label: item.monthName,
        days: daysInMonth,
      };
    })
    .sort((a, b) => a.value - b.value); // Sort months in ascending order

  // Filter months based on the provided `year`
  let filteredMonths = months;

  return filteredMonths;
};

export const fetchMonths = async (year) => {
  const response = await api.get("/api/months");
  const data = response.data;

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  const currentDate = now.getDate();
  const lastDayOfCurrentMonth = new Date(currentYear, currentMonth, 0).getDate();

  const months = data
    .map((item) => {
      let daysInMonth;
      if (year === currentYear && item.monthId === currentMonth) {
        daysInMonth = currentDate;
      } else {
        daysInMonth = new Date(year, item.monthId, 0).getDate();
      }
      return {
        value: item.monthId,
        label: item.monthName,
        days: daysInMonth,
      };
    })
    .sort((a, b) => a.value - b.value);

  let filteredMonths = months;
  if (year) {
    if (year === currentYear) {
      filteredMonths = months.filter((m) => {
        if (m.value < currentMonth) return true;
        if (m.value === currentMonth) {
          return currentDate === lastDayOfCurrentMonth;
        }
        return false;
      });
    } else if (year > currentYear) {
      filteredMonths = [];
    } else {
      filteredMonths = months;
    }
  }

  return filteredMonths;
};

export const fetchEmployeePostingByLocation = async (payload) => {
  const response = await api.post("/api/employee-posting/by-location", payload);
  return response.data;
};

export const getMonthlyAttendanceReport = async (filters) => {
  const response = await api.get("/api/attendance/monthly", {
    params: filters,
  });
  return response.data;
};

export const getPendingAttendance = async (filters) => {
  const response = await api.get("/api/attendance/pending", {
    params: filters,
  });
  return response.data;
};
export const verifyAttendanceBulk = async (payload) => {
  const response = await api.post("/api/attendance/verify/bulk", payload);
  return response.data;
};

export const submitAttendance = (payload, hasResubmit) => {
  if (hasResubmit) {
    return api.patch("/api/attendance", payload); // update
  }
  return api.patch("/api/attendance", payload); // create
};

export const getFinalAttendanceReport = async (filters) => {
  const response = await api.get("/api/attendance/monthly/district-report", {
    params: filters,
  });
  return response.data;
};

export const getAnnexureEntry = async (filters) => {
  const response = await api.get("/api/attendance/monthly/designation-summary", {
    params: filters,
  });
  return response.data;
};

export const getAnnexureReport = async (filters) => {
  const response = await api.get("/api/annexure-a/fetch", {
    params: filters,
  });
  return response.data;
};
// export const getEmployeeForAttendance=async(state,district,clients,project)=>{
//    const response = await api.get(`/api/employee-posting/employees?stateId=${state}&districtId=${district}&clientId=${clients}&projectId=${project}`)
//    return response;
// }
export const getEmployeeForAttendance = async (state, district, clients, project) => {
  let url = `/api/employee-posting/employees?stateId=${state}&districtId=${district}&clientId=${clients}`
  if (project) {
    url += `&projectId=${project}`;
  }

  const response = await api.get(url)
  return response;
}

export const getLeavesEmployees = async (stateId,clients, districtId) => {
  try {

    let url = `/api/employee-posting/basic?stateId=${stateId}&clientId=${clients}`;
    if (districtId) {
      url += `&districtId=${districtId}`;
    }

    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching PF not registered employees:", error);
    throw error;
  }
};

export const selfAttendance = async (formData) => {
  try {
    const response = await api.post(
      "api/attendance/capture",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );

    return response;
  } catch (err) {
    throw err;
  }
};

export const getEmployeSatateAndDistrictWise = async (stateId, districtId) => {
  try {
    const response = await api.get(`/api/attendance/employees/by-state-district?stateId=${stateId}&districtId=${districtId}`)
    return response.data;
  }
  catch (error) {
    console.log("error", error)
  }

}


export const gettingAttendaceEmployeeWise = async (stateId, districtId, employee, fromDate, toDate) => {
  // Add validation for dates
  if (!fromDate || !toDate) {
    console.error("Invalid dates:", { fromDate, toDate });
    throw new Error("From date and To date are required");
  }

  try {
    const formattedFromDate = format(new Date(fromDate), 'yyyy-MM-dd');
    const formattedTodate = format(new Date(toDate), 'yyyy-MM-dd');

    const response = await api.get(`/api/attendance/employee-attendance?stateId=${stateId}&districtId=${districtId}&employeeUniqueId=${employee}&fromDate=${formattedFromDate}&toDate=${formattedTodate}`);
    return response.data;
  } catch (error) {
    console.log("error", error);
    throw error; // Re-throw the error so it can be caught in handleSubmit
  }
}
